import * as z$1 from "zod/v4";
//#region src/schemas/local-machine/recovery.ts
const LOCAL_MACHINE_RECOVERY_SCHEMA_VERSION = 1;
const localMachineIssueCodeSchema = z$1.enum([
	"local_machine.storage.exhausted",
	"local_machine.storage.not_writable",
	"local_machine.permission.denied",
	"local_machine.resources.exhausted",
	"local_machine.background_execution.blocked",
	"local_machine.concurrency.active",
	"local_machine.concurrency.orphaned",
	"local_machine.failure.unknown"
]);
const localMachineOperationSchema = z$1.enum([
	"create_lock",
	"read_local_state",
	"write_local_state",
	"start_background_service",
	"start_process",
	"unknown"
]);
const localMachineRecoveryPolicySchema = z$1.enum([
	"automatic",
	"retry_with_backoff",
	"user_action",
	"diagnostics"
]);
const LOCAL_MACHINE_RECOVERY_POLICY_BY_CODE = {
	"local_machine.storage.exhausted": "user_action",
	"local_machine.storage.not_writable": "user_action",
	"local_machine.permission.denied": "user_action",
	"local_machine.resources.exhausted": "user_action",
	"local_machine.background_execution.blocked": "user_action",
	"local_machine.concurrency.active": "user_action",
	"local_machine.concurrency.orphaned": "user_action",
	"local_machine.failure.unknown": "diagnostics"
};
function resolveLocalMachineRecoveryPolicy(code) {
	if (!Object.hasOwn(LOCAL_MACHINE_RECOVERY_POLICY_BY_CODE, code)) return null;
	return LOCAL_MACHINE_RECOVERY_POLICY_BY_CODE[code];
}
const localMachineUserMessageSchema = z$1.string().trim().min(1).max(512);
const localMachineDiagnosticTextSchema = z$1.string().trim().min(1).max(2048);
const localMachineAgentMessageSchema = z$1.string().trim().min(1).max(1025);
function formatLocalMachineIssueMessage(issue) {
	return issue.primaryAction ? `${issue.summary} ${issue.primaryAction}` : issue.summary;
}
const localMachineIssueSchema = z$1.strictObject({
	schemaVersion: z$1.literal(1),
	code: localMachineIssueCodeSchema,
	operation: localMachineOperationSchema,
	recoveryPolicy: localMachineRecoveryPolicySchema,
	summary: localMachineUserMessageSchema,
	primaryAction: z$1.union([localMachineUserMessageSchema, z$1.null()]),
	diagnostics: z$1.strictObject({
		systemCode: z$1.union([z$1.string().trim().min(1).max(64), z$1.null()]),
		detail: z$1.union([localMachineDiagnosticTextSchema, z$1.null()])
	})
}).superRefine((value, context) => {
	const expectedPolicy = resolveLocalMachineRecoveryPolicy(value.code);
	if (value.recoveryPolicy !== expectedPolicy) context.addIssue({
		code: "custom",
		message: `recovery policy must be ${expectedPolicy} for ${value.code}`,
		path: ["recoveryPolicy"]
	});
});
const localMachineIssueAgentEventSchema = z$1.strictObject({
	type: z$1.literal("error"),
	code: localMachineIssueCodeSchema,
	message: localMachineAgentMessageSchema,
	requestId: z$1.string().trim().min(1).max(256).optional(),
	payload: z$1.strictObject({ localMachineIssue: localMachineIssueSchema })
}).superRefine((value, context) => {
	if (value.code !== value.payload.localMachineIssue.code) context.addIssue({
		code: "custom",
		message: "agent event code must match local machine issue code",
		path: ["code"]
	});
	const expectedMessage = formatLocalMachineIssueMessage(value.payload.localMachineIssue);
	if (value.message !== expectedMessage) context.addIssue({
		code: "custom",
		message: "agent event message must match local machine issue copy",
		path: ["message"]
	});
});
//#endregion
export { LOCAL_MACHINE_RECOVERY_POLICY_BY_CODE, LOCAL_MACHINE_RECOVERY_SCHEMA_VERSION, formatLocalMachineIssueMessage, localMachineIssueAgentEventSchema, localMachineIssueCodeSchema, localMachineIssueSchema, localMachineOperationSchema, localMachineRecoveryPolicySchema, resolveLocalMachineRecoveryPolicy };

//# sourceMappingURL=recovery.js.map